import { sortingHelper, Filters } from '@ui/src';
import { Card } from '../types';

const filtersHelper = (
  items: Card[],
  sortKey: string,
  direction: 'asc' | 'desc',
  filters: Filters,
): Card[] => {
  let nextItems: Card[] = items;

  Object.keys(filters).map((fieldName) => {
    if (filters[fieldName]) {
      nextItems = nextItems.filter((item) => {
        let value;

        if (Array.isArray(filters[fieldName])) {
          value = filters[fieldName].value.includes(
            item[fieldName as keyof Card] as string,
          );
        } else {
          value = (item[fieldName as keyof Card] as string)
            .toLowerCase()
            .includes(filters[fieldName].value[0].toLowerCase());
        }

        return value;
      });
    }

    return nextItems;
  });

  if (sortKey && direction) {
    nextItems = sortingHelper<Card>(nextItems, sortKey, direction);
  }

  return nextItems;
};

export default filtersHelper;
